const setLibraryOmniture = () => {
    var pageInfo = {
        pageName: 'MY Photos',
        siteServiceName: "Library",
        primaryCategory: "My Photos",
        loginState: 'NO',
        accountId: 'GUEST',
        userType: 'GUEST',
        regType: 'GUEST'
    };
    pageInfo.userInfo = {
        profile: {
            profileInfo: {
                loginState: "YES",
                userAccount: 'GUEST',
                customerStatus: '',
                userType: 'GUEST',
                regType: 'GUEST',
                returnUser: ''
            }
        }
    }
    photoOrg.omniture = new Omniture(pageInfo);
}
export const getUrlParamViaOrShareType = () => {
    return photoOrg.Util.getURLParameter('via') || photoOrg.Util.getURLParameter('shareType')
}
export const getUrlParamViaToken = () =>{
    return photoOrg.Util.getURLParameter('token')
}
export const handlePageNameOnLoad = () => {
    try{
        setLibraryOmniture();
        photoOrg.omnitureParams = {};
        photoOrg.omnitureParams.shareType = "Link"
        var shareTypeText = getUrlParamViaOrShareType() || ""
        if(shareTypeText){
            if(shareTypeText == "link"){
                shareTypeText = '';
            }
            photoOrg.omnitureParams.pageName = "MY Photos :Albums: "+shareTypeText+"Public Share";
        }else if(getUrlParamViaToken()){
            shareTypeText = "Email"
            photoOrg.omnitureParams.pageName = "MY Photos :Albums: "+shareTypeText+" Share";
        }

        photoOrg.omniture.getPageInfoForPublicShare({ 'pageName': photoOrg.omnitureParams.pageName})
    }catch(e){
    }
}

export default (response) => {
    const omnitureParams = photoOrg.omnitureParams;
    omnitureParams.numPhotosShared = response.assetsLength;
    if (photoOrg.omniture) {
        try{
            photoOrg.omniture.trackPublicShareOmnitureEvent(omnitureParams,false);
        }catch (e){
            photoOrg.cLog('Omniture tracking failed because trackPublicShareOmnitureEvent was undefined');
        }
    } else {
        photoOrg.cLog('Ominture tracking failed because it was undefined');
    }
    return null;     
}

